import moment from 'moment';

export const twoDigitalsFormat = (n: number) => (Number(n) < 10 ? `0${Number(n)}` : String(n));

export const formatDateConditionally = (date: string | null | undefined): string => {
  if (!date) return '-';

  const dateMoment = moment(date);
  const currentYear = moment().year();

  if (dateMoment.year() === currentYear) {
    return dateMoment.format('DD-MMM HH:mm');
  }

  return dateMoment.format('DD-MMM YYYY');
};

export const secondsToInputDisplay = (sec: number | null) => {
  const seconds = sec || 0;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds - h * 3600) / 60);
  const s = seconds - h * 3600 - m * 60;
  return `${twoDigitalsFormat(h)}:${twoDigitalsFormat(m)}:${twoDigitalsFormat(s)}`;
};

export const convertSecondsToObject = (
  t: number | null | undefined,
  isMilliseconds = false,
  toNumber = false,
  includeDays = false
): {
  d: number | string;
  h: number | string;
  m: number | string;
  s: number | string;
  ms?: number;
} => {
  const tNumber = t ?? 0;
  let time = tNumber;

  if (!time) {
    return { d: '0', h: '0', m: '00', s: '00' };
  }

  if (isMilliseconds) {
    time = Math.floor(time / 1000);
  }

  const days = includeDays ? Math.floor(time / (60 * 60 * 24)) : 0;
  const hours = includeDays ? Math.floor((time % (60 * 60 * 24)) / (60 * 60)) : Math.floor(time / (60 * 60));
  let minutes: number | string = Math.floor((time % (60 * 60)) / 60);
  let seconds: number | string = Math.floor(time % 60);

  if (minutes < 10 && !toNumber) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10 && !toNumber) {
    seconds = `0${seconds}`;
  }

  const data: {
    d: number | string;
    h: number | string;
    m: number | string;
    s: number | string;
    ms?: number;
  } = {
    d: days,
    h: hours,
    m: minutes,
    s: seconds,
  };

  if (isMilliseconds) {
    data.ms = Math.round((tNumber / 1000 - time) * 1000);
  }

  return data;
};
